import styled from 'styled-components';
import Theme from '../theme/Theme';

export const WhiteCard = styled.div`
  background-color: ${Theme.white};
  border-radius: 15px;
  padding: 20px;
  position: relative;

  .dps-Audience-Table {
    min-height: 500px;
  }

  @media only screen and (min-width: 768px) {
    // horizontal scroll bar
    .dps-Audience-Table {
      overflow: auto;

      ::-webkit-scrollbar {
        width: 4px;
        height: 3px;
      }
      ::-webkit-scrollbar-track {
        background-color: ${Theme.white};
      }
      ::-webkit-scrollbar-thumb {
        background-color: ${Theme.gray11};
      }

      max-height: calc(100vh - 500px);
      overflow: auto;
    }
  }

  .DSP-audience-label {
    display: inline-flex;

    .add-new-query {
      padding-top: 10px;
      margin-left: 10px;
      position: relative;
      color: ${Theme.gray40};
      cursor: pointer;
      .add-icon {
        font-size: ${Theme.extraSmall};
        color: ${Theme.orange};
        margin-right: 7px;
      }
    }

    @media only screen and (min-width: 766px) {
      .new-query-div {
        position: absolute;
        background-color: #f4f6fc;
        color: ${Theme.gray90} !important;
        padding: 20px;
        min-width: 400px;
        left: 230px;
        top: 30px;
        z-index: 9999;
      }
    }
  }

  @media only screen and (max-width: 766px) {
    .new-query-div {
      position: absolute;
      background-color: #f4f6fc;
      color: ${Theme.gray90} !important;
      padding: 20px;
      z-index: 9999;
      left: 0px;
      min-width: 300px;
      top: 30px;
    }
  }

  .DSP-audience-new-query-footer {
    .letter-count {
      float: left;
    }
    .action-btn {
      float: right;
    }
  }

  .COS-view-label {
    padding-top: 10px;
    color: ${Theme.black};
    font-weight: bold;
  }

  &.card-with-border {
    border: 1px solid ${Theme.gray11};
    border-radius: 8px;
    padding: 15px;
  }

  .creative-upload {
    background: ${Theme.gray8};
    bordertopleftradius: 8px;
    bordertoprightradius: 8px;
    padding: 15px;
  }

  .creative-add-project {
    position: absolute;
    background: ${Theme.gray8};
    input {
      height: 50px;
      border: none;
      background: ${Theme.gray8};
      &:focus {
        outline: none !important;
        border-width: 0px !important;
        border: none !important;
      }
    }
  }

  &.selected-card {
    border: 0.1rem dotted #bfc5d2;
  }

  .green {
    color: ${Theme.lighterGreen};
  }
  &.header-table {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    padding-bottom: 0;
  }
  &.table-card {
    padding: 0 20px;
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }

  &.fix-height {
    flex-wrap: wrap;
    flex: initial;
    height: 100%;
  }

  .text-extra-small {
    font-size: ${Theme.textExtraSmall};
    color: ${Theme.black};
  }

  .text-small-gray {
    font-size: ${Theme.extraSmall};
    color: ${Theme.gray40};
  }

  .contract-status {
    float: left;
    max-width: 80%;
    width: 100%;
    word-break: keep-all;
    &.one-time-service {
      max-width: 75%;
    }
  }

  .company-contract-height {
    max-height: 145px;
    overflow: auto;
  }
  .bbe-goals-partners {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      display: inline-block;
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .edit-details {
    position: absolute;
    right: 23px;
    font-size: ${Theme.extraNormal};
    color: ${Theme.gray85};
    top: 22px;
    cursor: pointer;

    &.edit-brand-details {
      top: 20px;
    }
    img {
      width: 16px;
      margin-right: 4px;
      vertical-align: text-top;
    }
    @media only screen and (max-width: 1170px) {
      right: 8px;
      img {
        width: 14px;
        margin-right: 2px;
      }
    }
  }

  &.left-border {
    padding: 25px 25px 25px 0;
  }
  .green-text {
    color: ${Theme.green};
    font-size: ${Theme.extraMedium};
  }
  .large-size {
    font-size: ${Theme.title};
  }
  .red-text {
    color: ${Theme.red};
  }

  .orange-text {
    color: ${Theme.red};
    cursor: pointer;

    .right-arrow-icon {
      vertical-align: middle;
      margin-left: 4px;
      width: 15px;

      &.green {
        color: ${Theme.lighterGreen};
      }
    }
  }
  .monthly-dsp-budget {
    color: ${Theme.red};
    font-size: ${Theme.normal};
    font-weight: 600;

    .on-track {
      color: ${Theme.lighterGreen};
    }

    .currency-amount {
      color: ${Theme.black};
    }
    .right-arrow-icon {
      vertical-align: middle;

      &.green {
        color: ${Theme.lighterGreen};
      }
    }

    .dot {
      background-color: ${Theme.gray35};
      border-radius: 50%;
      width: 3px;
      height: 3px;
      position: absolute;
      top: 26px;
      margin-left: 2px;
    }
  }

  .copy-info {
    position: relative;
    .copy-text {
      display: none;
    }

    .label {
      color: ${Theme.gray40};
      text-transform: uppercase;
      line-height: 22px;
      font-family: ${Theme.titleFontFamily};
      font-size: 11px;
      margin-bottom: 3px;
    }
    .label-info {
      color: ${Theme.black};
      font-size: ${Theme.normal};
    }

    &:hover {
      cursor: pointer;
      .copy-text {
        display: block;
        position: absolute;
        right: 0px;
        font-size: ${Theme.extraNormal};
        color: ${Theme.gray85};
        cursor: pointer;
        top: 28px;
        img {
          width: 12px;
          margin-right: 4px;
          top: 10px;
        }
      }
    }
  }
  .label {
    color: ${Theme.gray40};
    text-transform: uppercase;
    line-height: 22px;
    font-family: ${Theme.titleFontFamily};
    font-size: ${Theme.verySmall};
    margin-bottom: 3px;
    .info-icon {
      vertical-align: middle;
      width: 14px;
      margin-left: 8px;
      cursor: pointer;
    }
  }

  .label-info-medium {
    color: ${Theme.black};
    font-size: 18px;
    font-weight: normal;
  }

  .label-info {
    color: ${Theme.black};
    font-size: ${Theme.extraMedium};

    .master-card-icon {
      width: 20px;
      margin-right: 2px;
      vertical-align: top;
    }
    .ACH-status {
      background-color: #f1f1f5;
      border-radius: 5px;
      padding: 4px 10px 3px 4px;
      font-size: ${Theme.extraNormal};
      color: ${Theme.gray85};
      margin-left: 5px;
      .checked-mark-icon {
        width: 13px;
        margin-right: 2px;
        vertical-align: text-top;
      }
      .bell-icon {
        width: 16px;
        margin-right: 2px;
        vertical-align: text-top;
      }
    }
    .unverified {
      background-color: ${Theme.lightPink};
    }
    .pending {
      background-color: ${Theme.extraLightYellow};
    }
  }

  .phone-number {
    color: ${Theme.gray85};
    font-size: ${Theme.extraNormal};
    margin-top: 4px;
  }

  .dropdown-content-status {
    display: none;
    position: absolute;
    width: 220px;
    box-shadow: ${Theme.commonShadow};
    padding: 0px;
    z-index: 2;
    text-align: left;
    background: ${Theme.white};
    border: 1px solid ${Theme.gray9};
    border-radius: 8px;
    margin-top: 8px;
    left: 20px;

    li {
      list-style-type: none;
      font-size: ${Theme.extraMedium};
      color: ${Theme.black};
      padding: 15px;
      cursor: pointer;
      width: 100%;
      text-align: left;

      &:hover {
        background: ${Theme.gray8};
      }
    }
  }

  .increase-rate {
    color: ${Theme.lighterGreen};
    font-size: ${Theme.extraNormal};
    font-weight: 300;
    .green-arrow {
      width: 14px;
      margin-left: 0;
      margin-right: 3px;
      vertical-align: middle;
    }

    .red-arrow {
      width: 14px;
      transform: rotate(180deg);
      vertical-align: middle;
      margin-left: -2px;
      margin-right: 3px;
    }
    &.grey {
      color: ${Theme.gray40};
    }
    &.gray80 {
      color: ${Theme.gray80};
    }
    &.small-font {
      font-size: 12px;
      font-weight: 500;
    }
  }

  .left-details-card {
    padding: 0;
    margin: 0;
    list-style-type: none;
    li {
      margin-bottom: 23px;
      .left-details {
        color: ${Theme.black};
        padding: 0 0px 0px 25px;
        border-left: 3px solid ${Theme.white};
        img {
          width: 24px;
          margin-right: 15px;
          vertical-align: middle;
          &.file-contract {
            width: 28px;
          }
        }
        .collapse-arrow-icon {
          width: 25px;
          height: 25px;
          position: absolute;
          top: -27px;
          right: -12px;
        }
        &:hover {
          border-left: 3px solid ${Theme.orange};
          cursor: pointer;
          font-family: ${Theme.titleFontFamily};
        }
        &.active {
          border-left: 3px solid ${Theme.orange};
          cursor: pointer;
          font-family: ${Theme.titleFontFamily};
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      .sub-category {
        padding: 0;
        margin: 0;
        list-style-type: none;
        li.sub-category-details {
          font-size: ${Theme.normal};
          padding: 25px 0 0 80px;
          color: ${Theme.black};
          margin: 0;
          &.active {
            font-weight: bold;
          }
          &:hover {
            cursor: pointer;
            font-family: ${Theme.titleFontFamily};
          }
        }
      }
    }
  }

  .decrease-rate {
    color: ${Theme.red};
    font-size: ${Theme.extraNormal};
    font-weight: 300;
    .red-arrow {
      width: 14px;
      transform: rotate(180deg);
      vertical-align: middle;
      margin-left: -2px;
      margin-right: 3px;
    }

    .green-arrow {
      width: 14px;
      vertical-align: middle;
      margin-left: -2px;
      margin-right: 3px;
    }
    &.grey {
      color: ${Theme.gray40};
    }

    &.gray80 {
      color: ${Theme.gray80};
    }
    &.small-font {
      font-size: 12px;
      font-weight: 500;
    }
  }

  .sub-category-mobile-view {
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      display: inline-block;
      margin-right: 20px;
    }
  }

  .view-all-list {
    font-size: ${Theme.extraNormal};
    color: ${Theme.gray85};
    cursor: pointer;

    img {
      width: 16px;
      margin-left: 2px;
      vertical-align: bottom;
    }
  }
  .add-note-section {
    font-size: ${Theme.extraNormal};
    color: ${Theme.gray85};
    text-align: center;

    .red-chat-icon {
      width: 16px;
      vertical-align: middle;
      margin-right: 2px;
    }
  }

  .recurring-contact {
    padding: 0;
    margin: 0;
    list-style-type: none;
    display: inline-block;

    li {
      display: inline-block;
      margin-right: 18px;
      position: relative;

      &:last-child {
        margin-right: 0;
      }
      .dot {
        background-color: #8798ad;
        border-radius: 50%;
        width: 3px;
        height: 3px;
        position: absolute;
        top: 7px;
        margin-left: -10px;
      }

      .days-block {
        background: ${Theme.lighterOrange};
        padding: 5px 10px;
        border-radius: 5px;
        color: ${Theme.orange};
        font-size: ${Theme.extraNormal};

        .clock-icon {
          width: 14px;
          margin-right: 5px;
          vertical-align: text-top;
        }
      }
    }
  }
  #revenue_chart {
    width: 100%;
    position: relative;
    top: -16px;
    right: -19px;
  }

  .DSP-contract-retainer {
    .label {
      color: ${Theme.gray40};
      text-transform: uppercase;
      line-height: 22px;
      font-family: ${Theme.titleFontFamily};
      font-size: ${Theme.verySmall};
      margin-bottom: 1px;
    }
    span {
      color: ${Theme.black};
      font-size: ${Theme.normal};
      /* font-weight: 600; */
    }
  }

  .selected-list {
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      background: ${Theme.gray8};
      color: ${Theme.gray85};
      padding: 5px 10px;
      border-radius: 5px;
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 7px;
    }
  }

  &.activity-card {
    min-height: 530px;
  }

  .number-rate {
    color: ${Theme.gray80};
    font-size: 26px;
    word-break: break-all;
    font-family: ${Theme.baseFontFamily};
  }
  .perentage-value {
    color: ${Theme.lighterGreen};
    font-size: ${Theme.extraNormal};
    font-weight: 300;
    margin-left: -2px;

    &.down {
      color: ${Theme.red};
    }

    &.grey {
      color: ${Theme.gray40};
    }

    .red-arrow {
      width: 14px;
      transform: rotate(180deg);
      vertical-align: middle;
      margin-left: -2px;
      margin-right: 3px;
    }
    .green-arrow {
      width: 14px;
      vertical-align: bottom;
      vertical-align: middle;
      margin-left: -2px;
      margin-right: 3px;
    }

    img {
      width: 14px;
    }
  }

  .vs {
    color: ${Theme.gray40};
    font-size: ${Theme.extraMedium};
  }

  .dsp-spent-date {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      display: inline-block;
      margin-right: 20px;
    }
  }
  .rechart-item {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      display: inline-block;
      margin-right: 25px;
      vertical-align: middle;

      &:last-child {
        margin-right: none;
      }

      .weeks {
        display: flex;
        align-items: center;
        flex-direction: row;
      }

      .dashed-line {
        list-style-type: none;
        padding: 0;
        margin: 0;

        li {
          display: inline-block;
          margin-right: 3px;
          width: 6px;
          height: 2px;
          margin-bottom: 3px;

          &:last-child {
            margin-right: 6px;
          }
        }
      }

      .circle {
        width: 14px;
        height: 2px;
        margin-right: 6px;
      }
      .orange {
        background: ${Theme.baseColor};
      }
      .adSales {
        background: #0045b4;
      }
      .adSpend {
        background: #8c54ff;
      }
      .salesAdSpend {
        background: #89a43c;
      }
      .adConversion {
        background: #30a8bd;
      }
      .impressions {
        background: #d6a307;
      }
      .adCos {
        background: #e05d37;
      }
      .adRoas {
        background: #e05d37;
      }
      .adClicks {
        background: #c84ec6;
      }
      .adClickRate {
        background: #a04848;
      }

      .revenue,
      .orderedRevenue,
      .shippedCOGs {
        background: #0045b4;
      }
      .unitsSold,
      .glanceViews {
        background: #8c54ff;
      }
      .traffic {
        background: #30a8bd;
      }
      .conversion,
      .orderedUnits,
      .shippedUnits {
        background: #d6a307;
      }

      .dspImpressions {
        background: #0045b4;
      }
      .dspSpend {
        background: #8c54ff;
      }
      .dspTotalProductSales {
        background: #30a8bd;
      }
      .dspTotalRoas {
        background: #d6a307;
      }
      .dspTotalDpvr {
        background: #e05d37;
      }
      .dspTtlNewBrandPurchases {
        background: #89a43c;
      }
      .dspProductSales {
        background: #c84ec6;
      }
      .dspRoas {
        background: #a04848;
      }

      .costPerClick {
        background: #89a43c;
      }

      .revenueTotal {
        background: #0045b4;
      }
      .revenueOrganic {
        background: #74b035;
      }
      .revenuePpc {
        background: #c84ec6;
      }
      .revenueDsp {
        background: #e05d37;
      }

      .sponsoredAdSpend {
        background: #89a43c;
      }

      .adSpendTotal {
        background: #33beffd6;
      }

      .tacos,
      .conversionRate {
        background: #00be8e;
      }

      .adSpendPpc {
        background: #a47b40d6;
      }

      .adSpendDsp {
        background: #52d045d6;
      }

      .darkGray {
        background: ${Theme.gray35};
      }
      .gray {
        background: ${Theme.gray25};
      }
      .black {
        background: ${Theme.black};
      }
      .label-block {
        border-radius: 2px;
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
      span {
        color: ${Theme.black};
        font-size: ${Theme.normal};
      }
    }
  }
  .speed-rate {
    font-size: ${Theme.primaryTitleFontSize};
    color: ${Theme.black};
    margin-top: 75px;
    margin-bottom: 70px;
  }

  .average {
    color: ${Theme.black};
    font-size: ${Theme.primaryTitleFontSize};
    position: absolute;
    left: 0;
    right: 0;
    top: 150px;
    text-align: center;

    .out-off {
      color: ${Theme.gray40};
      font-size: ${Theme.extraNormal};
      margin-top: -6px;
    }
  }

  .last-update {
    color: ${Theme.gray40};
    font-size: ${Theme.extraNormal};
    bottom: 15px;
    left: 21px;
    position: absolute;
  }
  .seller-health {
    color: ${Theme.gray40};
    font-size: ${Theme.primaryTitleFontSize};

    &.positive {
      color: ${Theme.lighterGreen};
    }
  }
  .seller-update {
    color: ${Theme.gray40};
    font-size: 14px;
  }

  .solid-icon {
    margin-right: 15px;
    vertical-align: middle;
    float: left;
  }
  .image-title {
    float: left;
    font-size: ${Theme.extraNormal};
  }

  .service-icon {
    margin-right: 10px;
    vertical-align: middle;
  }

  .social-media-icons {
    padding: 0;
    margin: 0;
    list-style-type: none;

    li {
      display: inline-block;
      vertical-align: middle;
      padding-right: 8px;

      .social-media {
        width: 23px;
      }

      .social-icon-width {
        width: 27px;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  }

  .invoicesAmount {
    color: ${Theme.black};
    font-size: ${Theme.primaryTitleFontSize};
  }

  .creative-project-download {
    display: flex;
    align-items: center;
    float: right;
    justify-content: flex-end;
  }

  @media only screen and (min-width: 1920px) {
    .company-label-info {
      margin-top: 10px;

      &:first-child {
        margin-left: 0;
      }

      span {
        margin-left: 15px;
        max-width: 210px;

        &.mid-width {
          max-width: 250px;
          width: 100%;

          &.website {
            margin-left: 20px;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 1600px) {
    .contract-status {
      max-width: 85%;

      &.one-time-service {
        max-width: 80%;
      }
    }
  }
  @media only screen and (max-width: 1350px) and (min-width: 991px) {
    .average {
      font-size: 18px;
      top: 165px;
    }
  }
  @media only screen and (max-width: 1150px) {
    .company-label-info {
      margin-top: 10px;

      &:first-child {
        margin-left: 0;
      }
      span {
        margin-left: 15px;
        max-width: 70px;

        &.mid-width {
          max-width: 70px;
          width: 100%;
        }
      }
    }
    .contract-status {
      max-width: 70%;
      &.one-time-service {
        max-width: 65%;
      }
    }
  }
  @media only screen and (max-width: 991px) {
    .company-label-info {
      &:first-child {
        margin-left: 0;
      }

      .brand-label {
        margin-top: 10px;
        width: 100px;
      }
      span {
        margin-left: 15px;
        max-width: 210px;
        margin-top: 10px;

        &.mid-width {
          max-width: 230px;
          width: 100%;
          width: 100px;
        }

        &.company-size {
          margin-left: 18px;
        }
      }
    }
    .dsp-spent-date {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        display: inline-block;
        margin-right: 20px;

        .label-range {
          font-size: 16px;
        }
      }
    }
    .increase-rate {
      .green-arrow {
        margin-left: 0;
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .days-container {
      margin: 0 auto;
      float: none !important;
    }
    .rechart-item {
      margin: 0 auto;
      text-align: center;
      padding-top: 10px;
    }
    .bbpercent-graph-label {
      text-align: left !important;
    }
  }
  @media only screen and (max-width: 460px) {
    .brand-name {
      .company-status {
        white-space: nowrap;
      }
    }
  }

  @media only screen and (max-width: 407px) {
    .company-label-info {
      margin-top: 10px;

      span {
        margin-left: 5px;
        max-width: 117px;
        margin-top: 10px;

        &.mid-width {
          width: 100px;

          &.website {
            margin-left: 5px;
          }
        }

        &.company-size {
          margin-left: 5px;
        }
      }
    }
  }
`;
export default WhiteCard;
